import type { Overview } from '@manaro/contracts'
import { Card, CardHeader } from '@/shared/ui/card.tsx'
import { Progress } from '@/shared/ui/progress.tsx'
import { formatValue } from '@/shared/lib/format.ts'

const PLAN_COLORS = ['bg-brand-soft', 'bg-brand-mid', 'bg-[#4c8466]', 'bg-brand']

export function PlansCard({ plans, currency }: { plans: Overview['plans']; currency: string }) {
  const total = plans.reduce((sum, plan) => sum + plan.mrr, 0)

  return (
    <Card className="min-w-0 px-5.5 py-5">
      <CardHeader
        title="Тарифы"
        aside={<span className="text-[13px] text-ink-muted">{formatValue(total, 'currency', currency)} в месяц</span>}
      />
      <div className="flex flex-col gap-3.5">
        {plans.map((plan, index) => (
          <div key={plan.key} className="flex flex-col gap-1.5">
            <div className="flex items-baseline justify-between gap-2.5">
              <span className="truncate text-[14px] font-medium">{plan.name}</span>
              <span className="tabular shrink-0 text-[13px] text-ink-soft">{plan.count}</span>
            </div>
            <Progress
              value={plan.share}
              label={`${plan.name}: ${plan.share}%`}
              trackClassName="h-1.5 bg-line-soft"
              barClassName={PLAN_COLORS[index % PLAN_COLORS.length]}
            />
            <span className="text-[12.5px] text-ink-muted">
              {plan.price > 0
                ? `${formatValue(plan.price, 'currency', currency)} в месяц · даёт ${formatValue(plan.mrr, 'currency', currency)}`
                : 'бесплатный тариф'}
            </span>
          </div>
        ))}
      </div>
    </Card>
  )
}
